export const CONFIG_CLEAR = 'CONFIG_CLEAR';
export const CONFIG_FETCH = 'CONFIG_FETCH';
export const CONFIG_LOADED = 'CONFIG_LOADED';

export default {
    clear: CONFIG_CLEAR,
    fetch: CONFIG_FETCH,
    loaded: CONFIG_LOADED,
};
